const NBSP = ' ';

/**
 * French typesetting: a one-letter word (à, a, y, ô) never ends a line. Binds it to the
 * next word with a non-breaking space. Purely presentational, the copy is unchanged.
 */
export function glue(text: string): string {
	return text.replace(/(^|[\s ])([aàyôAÀYÔ]) /g, `$1$2${NBSP}`);
}

/**
 * Display headings: also bind the last two words so a line never ends on a lone word
 * ("plus douce, pas plus / rapide." becomes "plus douce, pas / plus rapide.").
 */
export function noWidow(text: string): string {
	const glued = glue(text);
	const last = glued.lastIndexOf(' ');
	return last > 0 && glued.indexOf(' ') !== last ? `${glued.slice(0, last)}${NBSP}${glued.slice(last + 1)}` : glued;
}
